module.exports = __webpack_public_path__ + "static/media/sample-activity-report-nz.cafdfbd7.pdf";